import React from "react";
import { Hospital, Stethoscope, Scissors, Landmark, Building, Car, Briefcase, Plane, GraduationCap } from "lucide-react";

const industries = [
  { Icon: Hospital, t: "Hospitals" },
  { Icon: Stethoscope, t: "Clinics" },
  { Icon: Scissors, t: "Salons" },
  { Icon: Landmark, t: "Banks" },
  { Icon: Building, t: "Government" },
  { Icon: Car, t: "Showrooms" },
  { Icon: Briefcase, t: "Offices" },
  { Icon: Plane, t: "Tourism" },
  { Icon: GraduationCap, t: "Education" },
];

export default function Industries() {
  return (
    <section id="industries" className="section" data-testid="industries-section">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div>
            <div className="eyebrow mb-4">Industries</div>
            <h2 className="font-serif text-4xl md:text-5xl text-white tracking-tight max-w-3xl leading-[1.05]">
              Built for the industries that <span className="gold-text italic">move the world</span>.
            </h2>
          </div>
          <p className="max-w-md text-white/55 text-sm leading-relaxed">
            Templates, integrations and best-practice flows tuned for nine industry verticals.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-5">
          {industries.map(({ Icon, t }, i) => (
            <div
              key={t}
              className="glass-card p-6 md:p-8 group relative overflow-hidden"
              data-testid={`industry-card-${i}`}
            >
              <div className="flex items-center gap-4">
                <div className="h-12 w-12 rounded-xl border border-gold-500/25 bg-gold-500/[0.06] flex items-center justify-center">
                  <Icon className="h-5 w-5 text-gold-300" strokeWidth={1.4} />
                </div>
                <div>
                  <div className="font-serif text-xl md:text-2xl text-white">{t}</div>
                  <div className="text-xs font-mono uppercase tracking-[0.2em] text-white/40">
                    {String(i + 1).padStart(2, "0")} / 09
                  </div>
                </div>
              </div>
              <div className="pointer-events-none absolute -bottom-10 -right-10 h-28 w-28 rounded-full bg-gold-500/0 group-hover:bg-gold-500/10 blur-2xl transition-all duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
